import React from "react";

const CustomerTypeSelector = ({ formData, setFormData }) => {
  return (
    <div className="inline-flex gap-x-2 bg-slate-200 shadow-md rounded-md p-2 items-center mb-4">
      <button
        onClick={() => setFormData({ ...formData, customerType: "inHouse" })}
        className={`flex items-center rounded-md p-2 ${
          formData.customerType === "inHouse"
            ? "bg-blue-500 text-white"
            : "bg-gray-200"
        }`}
      >
        Channel Partner Warehouse
      </button>
      <button
        onClick={() =>
          setFormData({ ...formData, customerType: "endCustomer" })
        }
        className={`flex items-center rounded-md p-2 ${
          formData.customerType === "endCustomer"
            ? "bg-blue-500 text-white"
            : "bg-gray-200"
        }`}
      >
        End Customer
      </button>
    </div>
  );
};

export default CustomerTypeSelector;
